module.exports = __webpack_public_path__ + "static/media/sto-express.3ac0d258.svg";